"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param env in soluto-api "env" should be set as process.env.STAGE with a resolveByStage set in the service
 * since process.env.NODE_ENV on soluto-api will result in 'production' despite being deployed to dev.
 */
exports.getEnvironmentAttributeKey = (attributeType, env) => {
    var _a;
    env = (_a = env !== null && env !== void 0 ? env : process.env.STAGE) !== null && _a !== void 0 ? _a : process.env.NODE_ENV;
    const isBehaviourTest = process.env.IS_BEHAVIOUR_TEST === 'true';
    const isProd = env === 'production' || env === 'prod';
    const isNotProd = isBehaviourTest || !isProd;
    const environmentPrefix = isNotProd ? 'dev-' : '';
    return `${environmentPrefix}${attributeType}`;
};
